// Optional: swaps a product card's image when hovering a colour swatch.
// Only active on <tangelos-swatches data-swap-image="true">.
// Safe to load more than once — the guard below makes re-execution a no-op.
(function () {
  if (customElements.get('tangelos-swatches')) return;

  class TangelosSwatches extends HTMLElement {
    connectedCallback() {
      if (this.dataset.swapImage !== 'true') return;

      const card = this.closest('product-card') || this.closest('.product-card');
      this.image = card ? card.querySelector('img') : null;
      if (!this.image) return;

      this.originalSrc = this.image.getAttribute('src');
      this.originalSrcset = this.image.getAttribute('srcset');

      this.handleOver = this.handleOver.bind(this);
      this.handleOut = this.handleOut.bind(this);

      this.addEventListener('pointerover', this.handleOver);
      this.addEventListener('pointerleave', this.handleOut);
      this.addEventListener('focusin', this.handleOver);
      this.addEventListener('focusout', this.handleOut);
    }

    disconnectedCallback() {
      this.removeEventListener('pointerover', this.handleOver);
      this.removeEventListener('pointerleave', this.handleOut);
      this.removeEventListener('focusin', this.handleOver);
      this.removeEventListener('focusout', this.handleOut);
    }

    handleOver(event) {
      // Touch taps should just follow the link, not preview.
      if (event.pointerType === 'touch') return;

      const swatch = event.target.closest('[data-preview]');
      if (!swatch || !this.image) return;

      // srcset wins over src, so it has to be cleared for the swap to show.
      this.image.removeAttribute('srcset');
      this.image.setAttribute('src', swatch.dataset.preview);
    }

    handleOut() {
      if (!this.image) return;
      if (this.originalSrcset) this.image.setAttribute('srcset', this.originalSrcset);
      if (this.originalSrc) this.image.setAttribute('src', this.originalSrc);
    }
  }

  customElements.define('tangelos-swatches', TangelosSwatches);
})();
